import { createAction } from '@reduxjs/toolkit';

// Interfaces
import { Constants } from './constants';
import { SelectAllItems } from '../../enums';
import { IMenubarButtonAction, IMenubarFolderItemAction } from '../../interfaces/menubar.interfaces';

export const selectMailsAction = createAction(Constants.MENUBAR_SELECTMAILS, (selectedAction: SelectAllItems) => ({
    payload: { selectedAction },
}));

export const setEnableDisableMoveToFolderMenuItem = createAction(
    Constants.MENUBAR_SET_ENABLE_DISABLE_MOVE_TO_FOLDER_MENU_ITEM,
    (disable: boolean) => ({
        payload: { disable },
    })
);

export const setEnableDisableReadUnreadButton = createAction(
    Constants.MENUBAR_SET_ENABLE_DISABLE_READUNREAD_BUTTON,
    (disable: boolean) => ({
        payload: { disable },
    })
);

export const setEnableDisableAddRemoveFlagButton = createAction(
    Constants.MENUBAR_SET_ENABLE_DISABLE_ADDREMOVE_FLAG_BUTTON,
    (disable: boolean) => ({
        payload: { disable },
    })
);

export const setEnablePrint = createAction(Constants.MENUBAR_SET_ENABLE_PRINT_BUTTON, (enable: boolean) => ({
    payload: { enable },
}));

export const setSelectedFolderMenuBarItemAction = createAction(
    Constants.MENUBAR_SET_SELECTED_ITEM_FOLDER_ACTION,
    (itemAction: IMenubarFolderItemAction) => ({
        payload: { itemAction },
    })
);

export const setSelectedMenuBarButtonAction = createAction(
    Constants.MENUBAR_SET_SELECTED_BUTTON_ACTION,
    (buttonAction: IMenubarButtonAction) => ({
        payload: { buttonAction },
    })
);

export const setTouchSelectActive = createAction(Constants.MENUBAR_SET_TOUCH_SELECT_ACTIVE, (active: boolean) => ({
    payload: { active },
}));
